import { render } from "./QueueCard.vue?vue&type=template&id=ff9e1514&scoped=true&ts=true"
import script from "./QueueCard.vue?vue&type=script&lang=ts"
export * from "./QueueCard.vue?vue&type=script&lang=ts"

import "./QueueCard.vue?vue&type=style&index=0&id=ff9e1514&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff9e1514"]])

export default __exports__